__turbopack_context__.v({
  "button": "LineLogin-module__lIOxgq__button",
  "container": "LineLogin-module__lIOxgq__container",
  "containerLandscape": "LineLogin-module__lIOxgq__containerLandscape",
  "divider": "LineLogin-module__lIOxgq__divider",
  "icon": "LineLogin-module__lIOxgq__icon",
  "text": "LineLogin-module__lIOxgq__text",
});
